<template>
    <div id="app">
        <PRINT ref="print"/>
        <b-container class="bv-example-row">
            <b-row>
                <b-col sm="12">
                    <div class="price_header" style="margin-bottom: 10px;">
                        <img src="./assets/images/header_title.svg" width="268" height="65" alt="">
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="6">
                    <div class="link_button">
                        <button class="btn" style="background-color: #646464"><a href="../itto_price/" target="_blank">itto<br>TT9001 -</a></button>
                        <button class="btn" style="background-color: #F7931E; color:white;" disabled>フィーロ<br>FF5201 -</button>
                        <button class="btn" style="background-color: #646464"><a href="../morris_price/" target="_blank">モリスデザインスタジオ<br>MM5901 -</a></button>
                        <button class="btn" style="background-color: #646464"><a href="../sh_price/" target="_blank">Sumiko Honda<br>SH2809 -</a></button>
                    </div>
                    <STEP1 ref="step1"/>
                    <STEP2/>
                </b-col>

                <b-col sm="6">
                    <STEP3/>
<!--                    <span style="font-size: 0.7rem;">{{$store.state.price_data.price_file}}&nbsp;&yen;{{$store.state.price_data.price}}</span>-->
                    <!--                    <span style="font-size: 0.7rem;" v-html="$store.state.price_data.price_load_data"/>-->
                    <!--                    <br>-->
                    <!--                    <span style="font-size: 0.7rem;">{{$store.state.price_data.price_add_file}}&nbsp;&yen;{{$store.state.price_data.price_add}}</span>-->
                    <!--                    <span style="font-size: 0.7rem;" v-html="$store.state.price_data.price_load_add_data"/>-->
                    <!--                    <br>-->
                    <STEP4/>
                    <STEP5/>
                    <PRICE/>
                    <b-row>
                        <b-col cols="12" sm="1"></b-col>
                        <b-col cols="12" sm="6">
                            <b-button v-b-modal.modal-1 style="margin-top: 1rem; width:180px; font-size: 0.9rem;" v-on:click="add_item()" variant="success">＋商品リストに追加</b-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </b-col>
                        <b-col cols="12" sm="5">
                            <b-button v-b-modal.modal-1 style="margin-top: 1rem; width:180px; font-size: 0.9rem;" v-on:click="toTop" variant="info">商品リストを確認</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <pre>
<!--    {{$store.state.xlsx_data.style_data}}-->
        </pre>

        <div>
            <b-modal id="modal-2" centered>
                <template slot="modal-header" slot-scope="{ close }">
                    <h5 class="w-100" style="text-align:center">対応不可理由</h5>
                </template>

                <p class="my-0">{{now_no_select_result}}</p>

                <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                    <b-button size="sm" variant="success" @click="ok()">
                        はい
                    </b-button>
                </template>
            </b-modal>
        </div>
        <div id="loader" v-if="$store.state.is_loading && Object.keys($store.state.xlsx_data).length=== 0 && Object.keys($store.state.xlsx_select_data).length === 0">
            <div id="loading_text" width="280" height="280">Loading...</div>
        </div>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas'
    import XLSX from 'xlsx'
    import STEP1 from './components/STEP1.vue'
    import STEP2 from './components/STEP2.vue'
    import STEP3 from './components/STEP3.vue'
    import STEP4 from './components/STEP4.vue'
    import STEP5 from './components/STEP5.vue'
    import PRICE from './components/PRICE.vue'
    import PRINT from './components/PRINT.vue'

    export default {
        name: 'app',
        components: {
            STEP1, STEP2, STEP3, STEP4, STEP5, PRICE, PRINT
        },
        computed: {
            item_number: {
                get: function () {
                    return this.$store.state.step1_data.item_number
                }
            },
            now_no_select_result: {
                get: function () {
                    return this.$store.state.now_no_select_result
                },
            }
        },
        data() {
            return {
                canvas_data:null,
                canvasData:null,
                canvas_data2:null,
            }
        },
        created: function () {
            this.loadXlsx()
            this.loadSelectXlsx()

        },
        methods: {
            toTop : function(){
                this.$refs.print.loadItem()
                window.scrollTo(0,0);
            },
            add_item : function(){
                window.scrollTo(0,0);
                this.$refs.print.add_item()
            },
            /**
             * PNG保存
             * 保存用の画面（選択ラグ）を表示
             * まずは画面をコピーしてcanvasに入れる→saveImage2へ
             */
            save_image:function (){
                html2canvas(document.querySelector("#print_area")).then(canvas => {
                    const canvas_img = document.body.appendChild(canvas)
                    this.saveImage2(canvas);
                    canvas_img.remove()
                });
            },
            /**
             * 保存処理 画面をコピーしたcanvasを作成し、それをPNG保存
             * @param _canvas
             */
            saveImage2:function (_canvas) {
                const h = _canvas.toDataURL("image/png").split(",")
                const b = h[0].split(":")[1].split(";")[0]
                const j = atob(h[1])
                const k = new Uint8Array(j.length)
                for (let i = 0; i < j.length; i++) {
                    k[i] = j.charCodeAt(i)
                }
                const e = new Blob([k], {type: b})
                const file_name = '価格データ.png'

                if (window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(e, file_name)
                } else {
                    const event = document.createEvent("MouseEvents")
                    event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
                    const a = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
                    a.href = (window.URL || window.webkitURL).createObjectURL(e)
                    a.download = file_name
                    a.dispatchEvent(event)
                }
            },

            /**
             * 初期データ読み込み
             */
            loadXlsx : function(){
                //価格データ取得
                const file = './item_data/item_data.xlsx';
                const req = new XMLHttpRequest()
                req.open('GET', file, true)
                req.responseType = 'arraybuffer'
                const scope = this

                req.onload = function () {
                    const data = new Uint8Array(req.response)
                    const workbook = XLSX.read(data, {type: 'array'})
                    let xlsx_data = scope.to_json(workbook)
                    //データを使いやすいよう品番で連想配列に変換
                    xlsx_data = scope.itemFormating(xlsx_data)
                    scope.$store.commit('updateXlsx', xlsx_data)
                    //読み込み完了後検索開始(子コンポーネント)
                    if(Object.keys(scope.$store.state.xlsx_data).length > 0 && Object.keys(scope.$store.state.xlsx_select_data).length > 0){
                        scope.$refs.step1.checkItemNumber()
                    }
                }
                 req.send();
            },
            /**
             * 初期データ読み込みセレクト情報
             */
            loadSelectXlsx : function(){
                //価格データ取得
                const file = './item_data/item_select.xlsx';
                const req = new XMLHttpRequest()
                req.open('GET', file, true)
                req.responseType = 'arraybuffer'
                const scope = this

                req.onload = function () {
                    const data = new Uint8Array(req.response)
                    const workbook = XLSX.read(data, {type: 'array'})
                    let xlsx_data = scope.to_json(workbook)
                    //データを使いやすいよう品番で連想配列に変換
                    xlsx_data = scope.selectFormating(xlsx_data)
                    scope.$store.commit('updateSelectXlsx', xlsx_data)
                    //読み込み完了後検索開始(子コンポーネント)
                    if(Object.keys(scope.$store.state.xlsx_data).length > 0 && Object.keys(scope.$store.state.xlsx_select_data).length > 0){
                        scope.$refs.step1.checkItemNumber()
                    }
                }
                req.send();
            },

            /**
             * Excelデータを使いやすい形に成形
             */
            itemFormating : function(xlsx_data){
                const return_obj = {}
                const item_data  = {}
                const no_select_result   = {}
                const style_group_pick   = []
                const style_group1_sort  = []
                const style_group2_data  = {}
                let group1 = ''
                let group2 = ''

                for(const key in xlsx_data.item_data){
                    item_data[xlsx_data.item_data[key]['見本帳品番']] = xlsx_data.item_data[key]
                }

                for(const key in xlsx_data.item_data){
                    no_select_result[xlsx_data.item_data[key]['見本帳品番']] = xlsx_data.no_select_result[key]
                }

                xlsx_data.style_data.sort(function(a,b){
                    if(a.sort_no < b.sort_no) return -1;
                    if(a.sort_no > b.sort_no) return 1;
                    return 0;
                });

                for(const key in xlsx_data.style_data){
                    if(xlsx_data.style_data[key].is_show === 0){continue;}
                    group1 = xlsx_data.style_data[key].group1
                    group2 = xlsx_data.style_data[key].group2
                    xlsx_data.style_data[key].style_id = parseInt(key)

                    if(parseInt(key) === 0 || parseInt(key) > 0 && xlsx_data.style_data[parseInt(key)-1].group1 !== group1){
                        style_group1_sort.push(group1)
                        style_group2_data[group1] = {}
                    }
                    if(typeof(style_group2_data[group1][group2]) === 'undefined'){
                        style_group2_data[group1][group2] = []
                    }
                    //ピックアップ指定
                    if(
                        xlsx_data.style_data[key].name === 'filo縫製' ||
                        xlsx_data.style_data[key].name === 'スタンダード縫製' ||
                        xlsx_data.style_data[key].name === 'ソフトウェーブ縫製' ||
                        xlsx_data.style_data[key].name === 'ファインウェーブ縫製' ||
                        (xlsx_data.style_data[key].group2==='ローマンシェード シングル' && xlsx_data.style_data[key].name === 'プレーンシェード')
                    ){
                        style_group_pick.push(xlsx_data.style_data[key])
                    }
                    style_group2_data[group1][group2].push(xlsx_data.style_data[key])
                }

                return_obj.item_data  = item_data
                return_obj.style_data = xlsx_data.style_data
                return_obj.style_group1_sort = style_group1_sort
                return_obj.style_group2_data = style_group2_data
                return_obj.file_rule = xlsx_data.file_rule
                return_obj.no_select_result = no_select_result
                return_obj.now_no_select_result = ''
                return_obj.style_group1_pick = style_group_pick
                return return_obj
            },

            /**
             * 選択肢データを加工
             */
            selectFormating : function(xlsx_data){
                const return_obj = {}
                const select_data  = {}
                const id_check  = {}
                const style_category = {}

                for(const style in xlsx_data){
                    if(typeof(select_data[style]) === 'undefined'){
                        select_data[style] = {}
                        id_check[style] = {}
                    }
                    let group1 = ''
                    let option_name = ''
                    for(const index in xlsx_data[style]){
                        if(xlsx_data[style][index].group2 === '-') {
                            group1 = xlsx_data[style][index].group1
                        }else{
                            group1 = xlsx_data[style][index].group2
                        }
                        if(typeof(select_data[style][group1]) === 'undefined'){
                            select_data[style][group1] = {}
                            id_check[style][group1] = {}

                        }
                        if(typeof(style_category[group1]) ==='undefined'){
                            style_category[group1] = style
                        }

                        let id_count = 1
                        for(const title in xlsx_data[style][index]){
                            if(typeof(select_data[style][group1][title]) === 'undefined'){
                                select_data[style][group1][title] = {}
                                select_data[style][group1][title].option = []
                                id_check[style][group1][title] = 1
                            }
                            option_name = xlsx_data[style][index][title]
                            if(option_name === '-'){continue}
                            if(typeof(select_data[style][group1][title][option_name]) === 'undefined'){
                                select_data[style][group1][title].option.push({ value : option_name, text : option_name })
                                select_data[style][group1][title][option_name] = id_check[style][group1][title]
                                id_check[style][group1][title] ++
                            }
                        }
                    }
                }
                return_obj.select_data    = select_data
                return_obj.xlsx_data      = xlsx_data
                return_obj.style_category = style_category
                return return_obj
            },

            /**
             * ワークブックのデータをjsonに変換
             * @param workbook
             */
            to_json: function (workbook) {
                const result = {};
                workbook.SheetNames.forEach(function (sheetName) {
                    const roa = XLSX.utils.sheet_to_json(
                        workbook.Sheets[sheetName],
                        {
                            raw: true,
                        });
                    if (roa.length > 0) {
                        result[sheetName] = roa
                    }
                });
                return result
            },
        }
    }

</script>

<style>
    #app {}
</style>
